<div class="statements statement-block">
	<div class="statements__title-block">
		<div class="statements__title-block-icon">
			<app-svg-documents
				width="100%"
				height="100%"
			></app-svg-documents>
		</div>
		<h3 class="statements__title-block-text">
			{{ title }}
		</h3>
	</div>

	@if (statementData$ | async; as statementData) {
		@if (statementData.data) {
			<ng-container mainContent>
				@if (statementData) {
					<div class="statement-block__content">
						@if (statementData.data.orderStatementEnabled) {
							<div class="statement-block__atm-wrapper">
								<article class="statement-block__atm">
									<app-svg-document-one-list
										class="statement-block__atm-image"
										width="30px"
										heigth="30px"
									></app-svg-document-one-list>
									<section class="statement-block__atm-content">
										<h2 class="statement-block__atm-title-text">
											Заявление о&nbsp;нештатной ситуации в&nbsp;банкомате при
											внесении наличных денежных средств
										</h2>
										<a
											class="link statement-block__atm-link"
											[routerLink]="['/statements/atm-create']"
										>
											Подать заявление
										</a>
									</section>
								</article>
							</div>
						}

						<div class="statement-block__description">
							<h3 class="statement-block__description-title">
								Подать обращение в&nbsp;банк можно:
							</h3>
							<ul class="statement-block__description-list">
								<li>В&nbsp;чате мобильного приложения или интернет-банка</li>
								<li>
									Через центр дистанционного обслуживания по&nbsp;телефону
									<a
										href="tel:8-495-748-0-748"
										class="link"
									>
										8-495-748-0-748
									</a>
								</li>
								<li>
									В&nbsp;
									<a
										href="https://www.rsb.ru/about/branch"
										class="link"
										target="_blank"
									>
										офисе
									</a>
									банка
								</li>
								<li>
									По&nbsp;юридическому адресу: ул. Ткацкая, д.36, г.Москва, 105187
								</li>
							</ul>
						</div>

						<div class="statements__title-block">
							<h3 class="statements__sub-title-block-text">Ваши заявления</h3>
						</div>
						<div id="statements">
							@if (statementData.data.claims && statementData.data.claims.length) {
								<div class="statements__list-wrapper">
									<app-list
										[items]="statementData.data.claims"
										[emptyLabel]="emptyListText"
										[defaultLimitTo]="5"
										[expandStep]="5"
										[expandLabel]="'Показать еще'"
										[collapseLabel]="'Скрыть'"
									>
										<ng-template let-item>
											<app-statement-item
												[title]="item.caption"
												[item]="item"
											></app-statement-item>
										</ng-template>
									</app-list>
								</div>
								@if (statementData.data.signAllAvailable) {
									<a
										class="button statement-block__sign-all-button"
										[routerLink]="['/statements/sign-all-statements']"
									>
										Подписать все
									</a>
								}
							} @else {
								<div class="statement-block__empty-text-block">
									<p class="statement-block__empty-text">
										У&nbsp;Вас отсутствуют заявления
									</p>
								</div>
							}
						</div>
					</div>
				}
			</ng-container>
		} @else if (statementData.error) {
			<div class="errors">
				<app-error-presenter [errors]="[statementData.error]"></app-error-presenter>
			</div>
		}
	} @else {
		<div class="statements__block-loader">
			<app-round-loader></app-round-loader>
		</div>
	}
</div>
